import React, { useContext } from 'react';
import { createContextualCan } from '@casl/react';
import { buildAbilityFor } from '../../config/ability';

export const AbilityContext = React.createContext(undefined);
export const ClientContext = React.createContext(undefined);
export default createContextualCan(AbilityContext.Consumer);

export const userForClaims = (claims) => ({
  ability: buildAbilityFor(claims['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'], claims.email),
  client: claims['http://schemas.microsoft.com/ws/2008/06/identity/claims/groupsid'],
});
export const useAbilityContext = () => useContext(AbilityContext);
export const useClientContext = () => useContext(ClientContext);
